/**
 * @file Route: productsingle
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { $, $all, on } from "@olmokit/dom";
import { globalData } from "@olmokit/core/data";
import "components/Breadcrumbs";
import "components/NewLook";
import "components/VisualPhoto";
import projects from "components/VisualProjects";
import products from "components/VisualProducts";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormType } from "components/Form";
import { Configurator } from "components/Configurator";
import scrollLock from "@olmokit/core/scroll/lock";
import { CardProduct } from "components/CardProduct";
import { ShareOn } from "components/ShareOn";
import { VisualVideo } from "components/VisualVideo";
import slider from "components/VisualSlider";
import { DialogDownload } from "components/Dialog/Download";
import { datalayerProd } from "components/Datalayer";
import "./index.scss";

console.log("Route productsingle/index.js mounted.");
 
const glideEl = $all(".glide");
if (glideEl.length > 0) {
    if (globalData.gallery) {
        slider('.VisualSlider:'+globalData.gallery);
    }
    if (globalData.sliderproducts) {
        products('.VisualProducts:'+globalData.sliderproducts);
    }
    if (globalData.sliderprojects) {
        projects('.VisualProjects:'+globalData.sliderprojects);
    }
}

replaceFragment("contactForm", "components.FormType").then(() => FormType());
// FormType();
Configurator();
ShareOn();
VisualVideo();
DialogDownload();

  CardProduct();

/* Open warehouse popups */

// get all ctas and all hidden popups
const popupBtn = $(".productsingle:popup");
const closeBtn = $(".productsingle:warehouseBg");
if (popupBtn) {
    on(popupBtn, "click", () => {
        let id = popupBtn.getAttribute('data-id');
        let product = popupBtn.getAttribute('data-product');
        // console.log('popup ID:', id, '; popup product:', product);
        // apply class to popup with specified id
        let dest = $("#"+id);
        dest.classList.add('is-in');   
        scrollLock.disable(document.body);
        datalayerProd(product, 'true', 'false');
    });
}

if (closeBtn) {
    // cycle through all close btns
    on(closeBtn, "click", () => {
        // remove class from open popup
        scrollLock.enable(document.body);
        let open = $(".productsingle:warehouse.is-in");
        open.classList.remove('is-in');
    });
}

// use keyboard to close popup
document.addEventListener('keydown', evt => {
    if (evt.key === 'Escape') {
    // remove class from open popup
        scrollLock.enable(document.body);
        let open = $(".productsingle:warehouse.is-in");
        open.classList.remove('is-in');
    }
});

const area = $('.productsingle:related');

if (area) {
    on(area, 'click',function(e){
        if (e.target.classList.contains('gtm-prodtitle')) {
            datalayerProd(e.target.getAttribute('data-product'), 'false', 'false');
        }
    });
}